
<div v-if="status">
    <!-- contact edit -->
    <d-contact-edit
        v-model     = "edit"
        :contact-id = "contactId"
        :company-id = "companyId"
        @saved      = "onContactSaved"
    />
    <!-- contact edit -->

    <div class="pt-0 pb-1"  style="border-radius: 4px">
        <v-row class="no-frame">
            <div class="w-100 pl-2 pt-0 pb-1 white">
                <v-col class="no-frame v-flex">
                    <c-toolbar-button
                        :size   = "22"
                        icon    = "mdi-account-plus"
                        :color  = "noContact ? 'error' : 'primary'"
                        tooltip = "Neuen Kontakt anlegen"
                        @click  = "onYes"
                    />
                    <c-toolbar-button
                        :size   = "22"
                        icon    = "mdi-reload"
                        color   = "primary"
                        tooltip = "Erneut vorbelegen"
                        @click  = "onReload"
                    />
                    <c-toolbar-button
                        :size   = "22"
                        icon    = "mdi-email"
                        color   = "primary"
                        tooltip = "Email senden"
                        @click  = "onMail"
                    />
                </v-col>

            </div>

        </v-row>
        <v-divider />

        <v-autocomplete
            v-if           = "contacts && contacts.length > 0"
            :items         = "contacts"
            item-value     = "id"
            item-text      = "name"
            :label         = "label"
            v-model        = "selected"
            :return-object = true
            :multiple      = "true"
            :clearable     = "false"
            :rules         = "rules"
            @change        = "onSelected"
            :class="background ? background : 'contact-select'"
            hide-details
            chips
        >
            <template v-slot:selection="data">
                <v-chip
                    v-if="data.index < count"
                    @click.stop  = "onEdit(data.item)"
                    @click:close = "onRemove(data.item)"
                    color        = "primary"
                    style        = "margin: 1px"
                    close
                    close-icon="mdi-close"
                >
                    <div class="pl-1">
                        <div class="selected-items">
                            {{ data.item.name }}
                        </div>
                        <div class="selected-item-email">
                            {{ data.item.email }}
                        </div>
                    </div>
                </v-chip>
                <span
                    v-if="data.index === count && selected.length > count"
                    class="items-others"
                >(+ {{ selected.length - count }})</span>
            </template>

            <template v-slot:item="data">
                <v-row class="no-frame pt-1 pb-1" >
                    <v-col class="no-frame">
                        <div style="font-size: 16px" class="v-flex">
                            <div class="pr-2" style="margin-top: -2px; margin-left: -10px;">
                                <v-icon size="18">{{ isPrefered (data.item) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                            </div>
                            <div style="margin-left: -2px;">
                                {{ data.item.name }}
                            </div>
                        </div>
                        <div style="font-size: 12px; padding-left: 15px; margin-top: -3px;" v-for="(role, index) in data.item.roles" :key="index">
                            {{ role.name }}
                        </div>
                        <div style="font-size: 12px; padding-left: 15px;">
                            {{ data.item.email }}
                        </div>
                    </v-col>
                </v-row>
            </template>
        </v-autocomplete>

        <div v-if="noContact">
            <v-alert
                dense
                outlined
                class="mt-1 mb-2"
                color="error"
                style="font-size: 15px"
            >
                {{ $t('contact.query.notExists') }}
            </v-alert>
        </div>
    </div>
</div>
